import { Route } from 'react-router-dom'
import WithdrawalsPage from './pages/withdrawals/WithdrawalsPage'
import TaxHarvestingSummaryPage from './pages/summary/TaxHarvestingSummaryPage'
import TaxHarvestingPlanPage from './pages/plan/TaxHarvestingPlanPage'
import RecommendationPage from './pages/plan/recommendation/RecommendationPage'

export const TaxHarvestingRoutes = () => [
  <Route
    key='tax-harvesting-withdrawals'
    path='/tax-harvesting/withdrawals'
    element={<WithdrawalsPage />}
  />,
  <Route key='tax-harvesting-summary' path='/tax-harvesting' element={<TaxHarvestingSummaryPage />} />,
  <Route key='tax-harvesting-plan' path='/tax-harvesting/plan' element={<TaxHarvestingPlanPage />} />,
  <Route
    key='tax-harvesting-recommendation'
    path='/tax-harvesting/recommendation'
    element={<RecommendationPage />}
  />
]
